import React from 'react';
import IconType from './iconType';

function FilterIcon({ color = '#424242', height = 16, width = 16, ...rest }: IconType) {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6615 2H3.32812C2.38546 2 1.91413 2 1.62146 2.27467C1.32813 2.54933 1.32812 2.992 1.32812 3.87667V4.33667C1.32812 5.028 1.32812 5.374 1.50146 5.66067C1.67479 5.94733 1.99012 6.126 2.62279 6.482L4.56479 7.57533C4.98879 7.814 5.20146 7.93333 5.35346 8.06533C5.66946 8.33933 5.86412 8.662 5.95212 9.05867C5.99479 9.248 5.99479 9.47067 5.99479 9.91533V11.6953C5.99479 12.3013 5.99479 12.6047 6.16279 12.8407C6.33079 13.0773 6.62946 13.194 7.22546 13.4273C8.47812 13.9167 9.10412 14.1613 9.54946 13.8827C9.99479 13.6047 9.99479 12.968 9.99479 11.6947V9.91467C9.99479 9.47067 9.99479 9.248 10.0375 9.058C10.1212 8.66944 10.3321 8.31989 10.6368 8.06467C10.7881 7.93333 11.0008 7.814 11.4248 7.57467L13.3668 6.48133C13.9988 6.126 14.3155 5.948 14.4881 5.66133C14.6615 5.37467 14.6615 5.028 14.6615 4.336V3.876C14.6615 2.992 14.6615 2.54933 14.3681 2.27467C14.0761 2 13.6048 2 12.6615 2Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default FilterIcon;
